module.exports = __webpack_public_path__ + "img/room02_braile.4726e317.png";